"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNestedObjValueExist = exports.assignNestedObj = exports.objectToList = exports.isElectron = exports.getNotificationTime = exports.timeText = exports.addOneZeroPrefix = exports.getTimeString = exports.getTime = exports.email2UID = exports.setGlobalDebugMode = exports.setGlobalEnv = exports.debug = exports.env = void 0;
exports.env = '';
exports.debug = true;
var setGlobalEnv = function (envName) {
    exports.env = envName;
};
exports.setGlobalEnv = setGlobalEnv;
var setGlobalDebugMode = function (isDebug) {
    exports.debug = isDebug;
};
exports.setGlobalDebugMode = setGlobalDebugMode;
var email2UID = function (str, replace) {
    if (!str) {
        return str;
    }
    return str.replace(/[&\/\\#,+()$~%.@'":*?<>{}]/g, replace ? replace : '-');
};
exports.email2UID = email2UID;
var getTime = function () {
    var date = new Date();
    return {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        date: date.getDate(),
        hour: date.getHours(),
        min: date.getMinutes(),
        sec: date.getSeconds(),
        milli: date.getMinutes()
    };
};
exports.getTime = getTime;
var getTimeString = function () {
    var date = new Date();
    return "".concat(date.getMonth() + 1, "/").concat(date.getDate(), "/").concat(date.getFullYear(), " ").concat(date.getHours(), ":").concat(date.getMinutes(), ":").concat((date.getSeconds() * 1000 + date.getMilliseconds()) / 1000);
};
exports.getTimeString = getTimeString;
var addOneZeroPrefix = function (num) {
    return num < 10 ? "0".concat(num) : "".concat(num);
};
exports.addOneZeroPrefix = addOneZeroPrefix;
var timeText = function (timestamp) {
    var date = new Date(timestamp);
    var year = date.getFullYear();
    var month = (0, exports.addOneZeroPrefix)(date.getMonth() + 1);
    var day = (0, exports.addOneZeroPrefix)(date.getDate());
    var hours = (0, exports.addOneZeroPrefix)(date.getHours());
    var mins = (0, exports.addOneZeroPrefix)(date.getMinutes());
    var secs = (0, exports.addOneZeroPrefix)(date.getSeconds());
    return "".concat(year, "/").concat(month, "/").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
};
exports.timeText = timeText;
var getNotificationTime = function () {
    var date = new Date();
    var month = (0, exports.addOneZeroPrefix)(date.getMonth() + 1);
    var date2 = (0, exports.addOneZeroPrefix)(date.getDate());
    var hours = (0, exports.addOneZeroPrefix)(date.getHours());
    var mins = (0, exports.addOneZeroPrefix)(date.getMinutes());
    return "".concat(date.getFullYear(), "\u5E74").concat(month, "\u6708/").concat(date2, "\u65E5 ").concat(hours, ":").concat(mins);
};
exports.getNotificationTime = getNotificationTime;
var isElectron = function () {
    return (typeof navigator === 'object' &&
        typeof navigator.userAgent === 'string' &&
        navigator.userAgent.indexOf('Electron') >= 0);
};
exports.isElectron = isElectron;
var objectToList = function (object, sortFunc) {
    if (!object) {
        return [];
    }
    var list = [];
    Object.keys(object).forEach(function (key) {
        list.push(object[key]);
    });
    if (sortFunc) {
        list.sort(function (a, b) {
            return sortFunc(a, b);
        });
    }
    return list;
};
exports.objectToList = objectToList;
var assignNestedObj = function (obj, keys, value) {
    var lastKeyIndex = keys.length - 1;
    for (var i = 0; i < lastKeyIndex; ++i) {
        var key = keys[i];
        if (obj[key] === undefined) {
            obj[key] = {};
        }
        obj = obj[key];
    }
    obj[keys[lastKeyIndex]] = value;
};
exports.assignNestedObj = assignNestedObj;
var isNestedObjValueExist = function (obj, keys) {
    var lastKeyIndex = keys.length - 1;
    for (var i = 0; i <= lastKeyIndex; ++i) {
        var key = keys[i];
        if (!obj || !obj.hasOwnProperty(key)) {
            return false;
        }
        obj = obj[key];
    }
    if (!obj) {
        return false;
    }
    return true;
};
exports.isNestedObjValueExist = isNestedObjValueExist;
//# sourceMappingURL=Utils.js.map